/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AppVersion = {
  __typename?: 'AppVersion';
  android?: Maybe<Scalars['String']['output']>;
  iOS?: Maybe<Scalars['String']['output']>;
};

export type ApproveReportInput = {
  id: Scalars['ID']['input'];
};

export type ApproveReportResponse = MutationResponse & {
  __typename?: 'ApproveReportResponse';
  success: Scalars['Boolean']['output'];
};

export type AuthUser = {
  __typename?: 'AuthUser';
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  opencart_customer_id?: Maybe<Scalars['Int']['output']>;
  phone_number: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type Avatar = {
  __typename?: 'Avatar';
  url: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  author: CommunityAuthor;
  body: Scalars['String']['output'];
  comments?: Maybe<Array<Comment>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  own_reaction?: Maybe<ReactionType>;
  post_id: Scalars['ID']['output'];
  published_at: Scalars['String']['output'];
  reaction_counts: ReactionCounts;
  reactions?: Maybe<Array<Reaction>>;
};

export type CommentsResponse = {
  __typename?: 'CommentsResponse';
  comments: Array<Comment>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
};

export type CommerceQueries = {
  __typename?: 'CommerceQueries';
  sales?: Maybe<SaleQueries>;
  stores?: Maybe<StoresQueries>;
};

export type CommunityAuthor = {
  __typename?: 'CommunityAuthor';
  avatar?: Maybe<Avatar>;
  avatar_url: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_following: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type CommunityMutations = {
  __typename?: 'CommunityMutations';
  createComment?: Maybe<Comment>;
  createImageUploadOptions?: Maybe<ImageUploadOptions>;
  createPost?: Maybe<Post>;
  createReaction?: Maybe<CreateReactionResponse>;
  deleteComment?: Maybe<DeleteCommentResponse>;
  deletePost?: Maybe<DeletePostResponse>;
  deleteReaction?: Maybe<DeleteReactionResponse>;
  follow?: Maybe<FollowResponse>;
  reportComment?: Maybe<ReportResponse>;
  reportPost?: Maybe<ReportResponse>;
  reportProfile?: Maybe<ReportResponse>;
  unfollow?: Maybe<FollowResponse>;
  updateComment?: Maybe<Comment>;
  updatePost?: Maybe<Post>;
};


export type CommunityMutationsCreateCommentArgs = {
  input?: InputMaybe<CreateCommentInput>;
};


export type CommunityMutationsCreateImageUploadOptionsArgs = {
  input?: InputMaybe<UploadImageInput>;
};


export type CommunityMutationsCreatePostArgs = {
  context?: InputMaybe<ContextInput>;
  input?: InputMaybe<CreatePostInput>;
};


export type CommunityMutationsCreateReactionArgs = {
  input?: InputMaybe<CreateReactionInput>;
};


export type CommunityMutationsDeleteCommentArgs = {
  comment_id: Scalars['ID']['input'];
};


export type CommunityMutationsDeletePostArgs = {
  post_id: Scalars['ID']['input'];
};


export type CommunityMutationsDeleteReactionArgs = {
  input?: InputMaybe<DeleteReactionInput>;
};


export type CommunityMutationsFollowArgs = {
  input?: InputMaybe<FollowInput>;
};


export type CommunityMutationsReportCommentArgs = {
  input?: InputMaybe<ReportCommentInput>;
};


export type CommunityMutationsReportPostArgs = {
  input?: InputMaybe<ReportPostInput>;
};


export type CommunityMutationsReportProfileArgs = {
  input?: InputMaybe<ReportProfileInput>;
};


export type CommunityMutationsUnfollowArgs = {
  input?: InputMaybe<FollowInput>;
};


export type CommunityMutationsUpdateCommentArgs = {
  input?: InputMaybe<UpdateCommentInput>;
};


export type CommunityMutationsUpdatePostArgs = {
  input?: InputMaybe<UpdatePostInput>;
};

export type CommunityQueries = {
  __typename?: 'CommunityQueries';
  comment?: Maybe<Comment>;
  comments?: Maybe<CommentsResponse>;
  followers?: Maybe<FollowersResponse>;
  following?: Maybe<FollowingResponse>;
  post?: Maybe<Post>;
  posts?: Maybe<PostsResponse>;
  profile?: Maybe<Profile>;
  reactions?: Maybe<ReactionsResponse>;
  replies?: Maybe<CommentsResponse>;
  reportReasons: Array<ReportReason>;
};


export type CommunityQueriesCommentArgs = {
  id: Scalars['ID']['input'];
};


export type CommunityQueriesCommentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  post_id: Scalars['ID']['input'];
};


export type CommunityQueriesFollowersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesFollowingArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesPostArgs = {
  id: Scalars['ID']['input'];
};


export type CommunityQueriesPostsArgs = {
  context?: InputMaybe<ContextInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type CommunityQueriesProfileArgs = {
  user_id: Scalars['ID']['input'];
};


export type CommunityQueriesReactionsArgs = {
  input: GetReactionsInput;
};


export type CommunityQueriesRepliesArgs = {
  comment_id: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Competition = {
  __typename?: 'Competition';
  body: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  lead?: Maybe<CompetitionParticipant>;
  own_participant?: Maybe<CompetitionParticipant>;
  participants_count: Scalars['Int']['output'];
  period: CompetitionPeriod;
  slug: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompetitionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: LanguageType;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionMutations = {
  __typename?: 'CompetitionMutations';
  createParticipant?: Maybe<CompetitionParticipant>;
  createVote?: Maybe<CreateCompetitionParticipantVoteResponse>;
  deleteVote?: Maybe<DeleteCompetitionParticipantVoteResponse>;
};


export type CompetitionMutationsCreateParticipantArgs = {
  input: CreateCompetitionParticipantInput;
};


export type CompetitionMutationsCreateVoteArgs = {
  participant_id: Scalars['ID']['input'];
};


export type CompetitionMutationsDeleteVoteArgs = {
  participant_id: Scalars['ID']['input'];
};

export type CompetitionParticipant = {
  __typename?: 'CompetitionParticipant';
  id: Scalars['ID']['output'];
  own_vote: Scalars['Boolean']['output'];
  post: Post;
  post_id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  user: CommunityAuthor;
  user_id: Scalars['ID']['output'];
  votes_count: Scalars['Int']['output'];
};

export type CompetitionParticipantInput = {
  entry_id: Scalars['ID']['input'];
};

export type CompetitionParticipantsInput = {
  competition_id: Scalars['ID']['input'];
};

export type CompetitionParticipantsResponse = {
  __typename?: 'CompetitionParticipantsResponse';
  next_page?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  participants: Array<CompetitionParticipant>;
  total: Scalars['Int']['output'];
};

export enum CompetitionParticipantsSortBy {
  Id = 'id',
  VotesCount = 'votes_count'
}

export enum CompetitionParticipantsSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type CompetitionParticipantsSortInput = {
  order?: InputMaybe<CompetitionParticipantsSortDirection>;
  sort?: InputMaybe<CompetitionParticipantsSortBy>;
};

export enum CompetitionPeriod {
  Current = 'current',
  Old = 'old',
  Upcoming = 'upcoming'
}

export type CompetitionQueries = {
  __typename?: 'CompetitionQueries';
  competition?: Maybe<Competition>;
  competitions?: Maybe<CompetitionsResponse>;
  participant?: Maybe<CompetitionParticipant>;
  participants?: Maybe<CompetitionParticipantsResponse>;
};


export type CompetitionQueriesCompetitionArgs = {
  input?: InputMaybe<CompetitionInput>;
};


export type CompetitionQueriesCompetitionsArgs = {
  filter: CompetitionsFilterInput;
  paginate?: InputMaybe<CursorPaginationInput>;
};


export type CompetitionQueriesParticipantArgs = {
  input?: InputMaybe<CompetitionParticipantInput>;
};


export type CompetitionQueriesParticipantsArgs = {
  input?: InputMaybe<CompetitionParticipantsInput>;
  paginate?: InputMaybe<SimplePaginationInput>;
  sort?: InputMaybe<CompetitionParticipantsSortInput>;
};

export type CompetitionsFilterInput = {
  language: LanguageType;
  period?: InputMaybe<CompetitionPeriod>;
};

export type CompetitionsResponse = {
  __typename?: 'CompetitionsResponse';
  competitions: Array<Competition>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type Content = Pattern;

export type Context = {
  __typename?: 'Context';
  entity?: Maybe<EntityType>;
  entity_id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<KindType>;
  language?: Maybe<LanguageType>;
};

export type ContextIndexInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language?: InputMaybe<LanguageType>;
};

export type ContextInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language: LanguageType;
};

export type ContextSearchInput = {
  entity?: InputMaybe<EntityType>;
  entity_id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<KindType>;
  language?: InputMaybe<LanguageType>;
};

export type CountryConfig = {
  __typename?: 'CountryConfig';
  bingoId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  legacyStore?: Maybe<Store>;
  legacyStoreId?: Maybe<Scalars['Int']['output']>;
  shopifyConfig?: Maybe<ShopifyConfig>;
};

export type CountryConfigInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  body: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  post_id: Scalars['ID']['input'];
};

export type CreateCompetitionParticipantInput = {
  body: Scalars['String']['input'];
  competition_id: Scalars['ID']['input'];
  images: Array<Scalars['String']['input']>;
  language: LanguageType;
};

export type CreateCompetitionParticipantVoteResponse = MutationResponse & {
  __typename?: 'CreateCompetitionParticipantVoteResponse';
  success: Scalars['Boolean']['output'];
};

export type CreatePostInput = {
  body: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateReactionInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
  type: ReactionType;
};

export type CreateReactionResponse = MutationResponse & {
  __typename?: 'CreateReactionResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateRowCounterInput = {
  name: Scalars['String']['input'];
};

export type CursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerContentResponse = {
  __typename?: 'CustomerContentResponse';
  content: Array<Maybe<Content>>;
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeleteAvatarResponse = MutationResponse & {
  __typename?: 'DeleteAvatarResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCommentResponse = MutationResponse & {
  __typename?: 'DeleteCommentResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompetitionParticipantVoteResponse = MutationResponse & {
  __typename?: 'DeleteCompetitionParticipantVoteResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteNotificationResponse = MutationResponse & {
  __typename?: 'DeleteNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type DeletePostResponse = MutationResponse & {
  __typename?: 'DeletePostResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteReactionInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteReactionResponse = MutationResponse & {
  __typename?: 'DeleteReactionResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteRowCounterResponse = MutationResponse & {
  __typename?: 'DeleteRowCounterResponse';
  success: Scalars['Boolean']['output'];
};

export enum EntityType {
  Competition = 'competition',
  Pattern = 'pattern',
  Product = 'product'
}

export type ExchangeTokenResponse = {
  __typename?: 'ExchangeTokenResponse';
  customerAccessToken?: Maybe<ShopifyCustomerAccessToken>;
  customerUserErrors?: Maybe<ShopifyCustomerUserErrors>;
};

export type FollowInput = {
  user_id: Scalars['ID']['input'];
};

export type FollowResponse = MutationResponse & {
  __typename?: 'FollowResponse';
  success: Scalars['Boolean']['output'];
};

export type FollowersResponse = {
  __typename?: 'FollowersResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  followers: Array<CommunityAuthor>;
  limit: Scalars['Int']['output'];
};

export type FollowingResponse = {
  __typename?: 'FollowingResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  following: Array<CommunityAuthor>;
  limit: Scalars['Int']['output'];
};

export type GetAvatarResponse = {
  __typename?: 'GetAvatarResponse';
  avatar_url?: Maybe<Scalars['String']['output']>;
};

export type GetNotificationsInput = {
  language: LanguageType;
  paginate?: InputMaybe<CursorPaginationInput>;
};

export type GetReactionsInput = {
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  post_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ReactionType>;
};

export enum ImageType {
  Jpg = 'jpg',
  Png = 'png'
}

export type ImageUploadOptions = {
  __typename?: 'ImageUploadOptions';
  file_url: Scalars['String']['output'];
  upload_endpoint: Scalars['String']['output'];
};

export enum KindType {
  Gallery = 'gallery',
  Qa = 'qa'
}

export enum LanguageType {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Sv = 'sv'
}

export type LoyaltyQueries = {
  __typename?: 'LoyaltyQueries';
  points?: Maybe<PointsResponse>;
};


export type LoyaltyQueriesPointsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ModerationMutations = {
  __typename?: 'ModerationMutations';
  approveReport?: Maybe<ApproveReportResponse>;
  rejectReport?: Maybe<RejectReportResponse>;
};


export type ModerationMutationsApproveReportArgs = {
  input: ApproveReportInput;
};


export type ModerationMutationsRejectReportArgs = {
  input: RejectReportInput;
};

export type ModerationPostsInput = {
  missing_answer?: InputMaybe<Scalars['Boolean']['input']>;
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModerationPostsResponse = SimplePaginationResponse & {
  __typename?: 'ModerationPostsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  posts: Array<Post>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ModerationQueries = {
  __typename?: 'ModerationQueries';
  posts?: Maybe<ModerationPostsResponse>;
  reports?: Maybe<ReportsResponse>;
};


export type ModerationQueriesPostsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<ModerationPostsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ModerationQueriesReportsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<ReportsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type MultipassTokenResponse = {
  __typename?: 'MultipassTokenResponse';
  multipassToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  community?: Maybe<CommunityMutations>;
  competition?: Maybe<CompetitionMutations>;
  moderation?: Maybe<ModerationMutations>;
  notification?: Maybe<NotificationMutations>;
  toc?: Maybe<TocMutations>;
  userContent?: Maybe<UserContentMutations>;
  users?: Maybe<UsersMutations>;
};

export type MutationResponse = {
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  actor: CommunityAuthor;
  actor_id: Scalars['ID']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  notifier_id: Scalars['ID']['output'];
  read_at?: Maybe<Scalars['String']['output']>;
  sourceable_id: Scalars['String']['output'];
  sourceable_type: SourceType;
  subject: NotificationSubject;
  targetable_id: Scalars['String']['output'];
  targetable_type: TargetType;
};

export type NotificationMutations = {
  __typename?: 'NotificationMutations';
  deleteNotification?: Maybe<DeleteNotificationResponse>;
  readNotification?: Maybe<ReadNotificationResponse>;
  readNotifications?: Maybe<ReadNotificationsResponse>;
  readUserNotifications?: Maybe<ReadUserNotificationsResponse>;
  seenUserNotifications: SuccessResponse;
  unreadNotification?: Maybe<UnreadNotificationResponse>;
  unreadNotifications?: Maybe<UnreadNotificationsResponse>;
};


export type NotificationMutationsDeleteNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsReadNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsReadNotificationsArgs = {
  input?: InputMaybe<ReadNotificationsInput>;
};


export type NotificationMutationsUnreadNotificationArgs = {
  notification_id: Scalars['ID']['input'];
};


export type NotificationMutationsUnreadNotificationsArgs = {
  input?: InputMaybe<UnreadNotificationsInput>;
};

export type NotificationQueries = {
  __typename?: 'NotificationQueries';
  notifications: NotificationsResponse;
};


export type NotificationQueriesNotificationsArgs = {
  input: GetNotificationsInput;
};

export type NotificationSubject = Comment | Post;

export enum NotificationType {
  CommunitySimple = 'community_simple'
}

export type NotificationsResponse = {
  __typename?: 'NotificationsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
  unseen: Scalars['Int']['output'];
};

export type Pattern = {
  __typename?: 'Pattern';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Point = {
  __typename?: 'Point';
  amount: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PointsResponse = {
  __typename?: 'PointsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  points: Array<Point>;
};

export type Post = {
  __typename?: 'Post';
  author: CommunityAuthor;
  body: Scalars['String']['output'];
  comments_count: Scalars['Int']['output'];
  context?: Maybe<Context>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  own_reaction?: Maybe<ReactionType>;
  published_at: Scalars['String']['output'];
  reaction_counts: ReactionCounts;
  teaser?: Maybe<Teaser>;
};

export type PostsResponse = {
  __typename?: 'PostsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  posts: Array<Post>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  followers_count: Scalars['Int']['output'];
  following_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  user: CommunityAuthor;
};

export type QaPostsInput = {
  missing_answer?: InputMaybe<Scalars['Boolean']['input']>;
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QaPostsResponse = {
  __typename?: 'QaPostsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  posts: Array<Post>;
};

export type QaQueries = {
  __typename?: 'QaQueries';
  posts?: Maybe<QaPostsResponse>;
  summary?: Maybe<QaSummaryResponse>;
};


export type QaQueriesPostsArgs = {
  context?: InputMaybe<ContextSearchInput>;
  input?: InputMaybe<QaPostsInput>;
  paginationInput?: InputMaybe<CursorPaginationInput>;
};


export type QaQueriesSummaryArgs = {
  context?: InputMaybe<ContextSearchInput>;
};

export type QaSummaryResponse = {
  __typename?: 'QaSummaryResponse';
  month: Array<Maybe<QaUserSummary>>;
  week: Array<Maybe<QaUserSummary>>;
};

export type QaUserSummary = {
  __typename?: 'QaUserSummary';
  count: Scalars['Int']['output'];
  user: CommunityAuthor;
};

export type Query = {
  __typename?: 'Query';
  appVersion?: Maybe<AppVersion>;
  commerce?: Maybe<CommerceQueries>;
  community?: Maybe<CommunityQueries>;
  competition?: Maybe<CompetitionQueries>;
  countryConfigs?: Maybe<Array<Maybe<CountryConfig>>>;
  customerContent: CustomerContentResponse;
  guestPattern?: Maybe<Pattern>;
  guestPatternBySku?: Maybe<Pattern>;
  loyalty?: Maybe<LoyaltyQueries>;
  moderation?: Maybe<ModerationQueries>;
  notification?: Maybe<NotificationQueries>;
  orderPatterns?: Maybe<Array<Maybe<Pattern>>>;
  pattern?: Maybe<Pattern>;
  patternBySku?: Maybe<Pattern>;
  qa?: Maybe<QaQueries>;
  shopify?: Maybe<ShopifyQueries>;
  toc?: Maybe<TocQueries>;
  userContent?: Maybe<UserContentQueries>;
  users?: Maybe<UsersQueries>;
};


export type QueryCountryConfigsArgs = {
  countryConfigInput?: InputMaybe<CountryConfigInput>;
};


export type QueryCustomerContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuestPatternArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryGuestPatternBySkuArgs = {
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
};


export type QueryOrderPatternsArgs = {
  checkout_token?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  shop?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatternArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatternBySkuArgs = {
  contactUUID?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  urlVersion?: InputMaybe<Scalars['String']['input']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  author: CommunityAuthor;
  label: Scalars['String']['output'];
};

export type ReactionCounts = {
  __typename?: 'ReactionCounts';
  cool: Scalars['Int']['output'];
  haha: Scalars['Int']['output'];
  in_love: Scalars['Int']['output'];
  love: Scalars['Int']['output'];
  smile: Scalars['Int']['output'];
  wow: Scalars['Int']['output'];
};

export enum ReactionType {
  Cool = 'cool',
  Haha = 'haha',
  InLove = 'in_love',
  Love = 'love',
  Smile = 'smile',
  Wow = 'wow'
}

export type ReactionsResponse = {
  __typename?: 'ReactionsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  reactions?: Maybe<Array<Reaction>>;
};

export type ReadNotificationResponse = MutationResponse & {
  __typename?: 'ReadNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type ReadNotificationsInput = {
  notifications: Array<Scalars['ID']['input']>;
};

export type ReadNotificationsResponse = MutationResponse & {
  __typename?: 'ReadNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type ReadUserNotificationsResponse = MutationResponse & {
  __typename?: 'ReadUserNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type RejectReportInput = {
  id: Scalars['ID']['input'];
};

export type RejectReportResponse = MutationResponse & {
  __typename?: 'RejectReportResponse';
  success: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  comment?: Maybe<Comment>;
  context?: Maybe<Context>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  offender: CommunityAuthor;
  post?: Maybe<Post>;
  processed_at?: Maybe<Scalars['String']['output']>;
  reason: ReportReason;
  reporter: CommunityAuthor;
};

export type ReportCommentInput = {
  comment_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportPostInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  post_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportProfileInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  profile_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReportReason = {
  __typename?: 'ReportReason';
  reason: Scalars['String']['output'];
};

export type ReportResponse = MutationResponse & {
  __typename?: 'ReportResponse';
  success: Scalars['Boolean']['output'];
};

export type ReportsInput = {
  newest_first?: InputMaybe<Scalars['Boolean']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportsResponse = SimplePaginationResponse & {
  __typename?: 'ReportsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  reports: Array<Report>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type RowCounter = {
  __typename?: 'RowCounter';
  count?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RowCountersResponse = {
  __typename?: 'RowCountersResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<RowCounter>>>;
  limit: Scalars['Int']['output'];
};

export type Sale = {
  __typename?: 'Sale';
  description: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  groups: Array<Maybe<SaleGroup>>;
  id: Scalars['Int']['output'];
  internal_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sale_banner_image_url?: Maybe<Scalars['String']['output']>;
  site_banner_image_url?: Maybe<Scalars['String']['output']>;
  spotlight_image_url?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
};

export type SaleGroup = {
  __typename?: 'SaleGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products: Array<Maybe<SaleProduct>>;
};

export type SaleProduct = {
  __typename?: 'SaleProduct';
  discount_percentage: Scalars['Float']['output'];
  discounted_price: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  opencart_id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sanity_id: Scalars['String']['output'];
  shopify_id: Scalars['String']['output'];
};

export type SaleQueries = {
  __typename?: 'SaleQueries';
  saleProducts?: Maybe<Array<Maybe<SaleProduct>>>;
  sales?: Maybe<Array<Maybe<Sale>>>;
};


export type SaleQueriesSaleProductsArgs = {
  sale_id: Scalars['Int']['input'];
};


export type SaleQueriesSalesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetAvatarInput = {
  file_url: Scalars['String']['input'];
};

export type SetAvatarResponse = MutationResponse & {
  __typename?: 'SetAvatarResponse';
  avatar_url?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShopifyConfig = {
  __typename?: 'ShopifyConfig';
  currency?: Maybe<Scalars['String']['output']>;
  storeEndpoint?: Maybe<Scalars['String']['output']>;
  storefront?: Maybe<ShopifyStorefront>;
};

export type ShopifyCustomerAccessToken = {
  __typename?: 'ShopifyCustomerAccessToken';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
};

export type ShopifyCustomerUserErrors = {
  __typename?: 'ShopifyCustomerUserErrors';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ShopifyQueries = {
  __typename?: 'ShopifyQueries';
  exchangeToken?: Maybe<ExchangeTokenResponse>;
  multipassToken?: Maybe<MultipassTokenResponse>;
};


export type ShopifyQueriesExchangeTokenArgs = {
  store_name: Scalars['String']['input'];
};


export type ShopifyQueriesMultipassTokenArgs = {
  redirect_to?: InputMaybe<Scalars['String']['input']>;
  store_name: Scalars['String']['input'];
};

export type ShopifyStorefront = {
  __typename?: 'ShopifyStorefront';
  endpoint?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicAccessToken?: Maybe<Scalars['String']['output']>;
};

export type SimplePaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SimplePaginationResponse = {
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum SourceType {
  Comment = 'comment',
  Reaction = 'reaction'
}

export type Store = {
  __typename?: 'Store';
  account: StoreAccountOptions;
  checkout_url: Scalars['String']['output'];
  contact_info: StoreContactInfo;
  country: Scalars['String']['output'];
  country_switcher_allowed: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  excludes_sales_taxes: Scalars['Boolean']['output'];
  google: StoreGoogleOptions;
  id: Scalars['Int']['output'];
  is_international: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  meta: StoreMeta;
  name: Scalars['String']['output'];
  payment: StorePaymentOptions;
  shipping: StoreShippingOptions;
  url: Scalars['String']['output'];
};

export type StoreAccountOptions = {
  __typename?: 'StoreAccountOptions';
  enabled: Scalars['Boolean']['output'];
  phone_number_required: Scalars['Boolean']['output'];
};

export type StoreContactInfo = {
  __typename?: 'StoreContactInfo';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type StoreGoogleOptions = {
  __typename?: 'StoreGoogleOptions';
  recaptcha_site_key?: Maybe<Scalars['String']['output']>;
  tag_manager_id?: Maybe<Scalars['String']['output']>;
};

export type StoreMeta = {
  __typename?: 'StoreMeta';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StorePaymentOptions = {
  __typename?: 'StorePaymentOptions';
  providers: Array<Maybe<Scalars['String']['output']>>;
};

export type StoreShippingOptions = {
  __typename?: 'StoreShippingOptions';
  delivery_time?: Maybe<Scalars['String']['output']>;
  free_shipping_threshold: Scalars['Int']['output'];
  min_shipping_price: Scalars['Float']['output'];
};

export type StoresQueries = {
  __typename?: 'StoresQueries';
  context?: Maybe<Store>;
  store?: Maybe<Store>;
  stores?: Maybe<Array<Maybe<Store>>>;
};


export type StoresQueriesContextArgs = {
  countryCode: Scalars['String']['input'];
};


export type StoresQueriesStoreArgs = {
  id: Scalars['Int']['input'];
};


export type StoresQueriesStoresArgs = {
  countryCode: Scalars['String']['input'];
};

export type SuccessResponse = MutationResponse & {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export enum TargetType {
  Comment = 'comment',
  Post = 'post'
}

export type Teaser = {
  __typename?: 'Teaser';
  description?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  site_name?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Term = {
  __typename?: 'Term';
  content: Scalars['String']['output'];
  path: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type TermAcceptResponse = MutationResponse & {
  __typename?: 'TermAcceptResponse';
  success: Scalars['Boolean']['output'];
};

export type TermDeclineResponse = MutationResponse & {
  __typename?: 'TermDeclineResponse';
  success: Scalars['Boolean']['output'];
};

export type TermStatusResponse = MutationResponse & {
  __typename?: 'TermStatusResponse';
  success: Scalars['Boolean']['output'];
};

export type TocMutations = {
  __typename?: 'TocMutations';
  accept?: Maybe<TermAcceptResponse>;
  decline?: Maybe<TermDeclineResponse>;
};


export type TocMutationsAcceptArgs = {
  alias: Scalars['String']['input'];
};


export type TocMutationsDeclineArgs = {
  alias: Scalars['String']['input'];
};

export type TocQueries = {
  __typename?: 'TocQueries';
  show?: Maybe<Term>;
  status?: Maybe<TermStatusResponse>;
};


export type TocQueriesShowArgs = {
  alias: Scalars['String']['input'];
};


export type TocQueriesStatusArgs = {
  alias: Scalars['String']['input'];
};

export type UnreadNotificationResponse = MutationResponse & {
  __typename?: 'UnreadNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type UnreadNotificationsInput = {
  notifications: Array<Scalars['ID']['input']>;
};

export type UnreadNotificationsResponse = MutationResponse & {
  __typename?: 'UnreadNotificationsResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateCommentInput = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdatePostInput = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileResponse = MutationResponse & {
  __typename?: 'UpdateProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateRowCounterInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadImageInput = {
  image_type: ImageType;
};

export type User = {
  __typename?: 'User';
  avatar: Avatar;
  avatar_url: Scalars['String']['output'];
  contact_uuid: Scalars['ID']['output'];
  country: UserCountry;
  created_at: Scalars['String']['output'];
  date_of_birth?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  experience_level: UserExperienceLevel;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  location_id: Scalars['Int']['output'];
  odoo_partner_id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  points_total: Scalars['Int']['output'];
  store_id: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type UserContentMutations = {
  __typename?: 'UserContentMutations';
  createRowCounter: RowCounter;
  deleteRowCounter: DeleteRowCounterResponse;
  updateRowCounter: RowCounter;
};


export type UserContentMutationsCreateRowCounterArgs = {
  input: CreateRowCounterInput;
};


export type UserContentMutationsDeleteRowCounterArgs = {
  id: Scalars['ID']['input'];
};


export type UserContentMutationsUpdateRowCounterArgs = {
  input: UpdateRowCounterInput;
};

export type UserContentQueries = {
  __typename?: 'UserContentQueries';
  rowCounter?: Maybe<RowCounter>;
  rowCounters?: Maybe<RowCountersResponse>;
};


export type UserContentQueriesRowCounterArgs = {
  id: Scalars['ID']['input'];
};


export type UserContentQueriesRowCountersArgs = {
  context?: InputMaybe<ContextInput>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCountry = {
  __typename?: 'UserCountry';
  id: Scalars['Int']['output'];
  iso_code_2: Scalars['String']['output'];
  iso_code_3: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserExperienceLevel = {
  __typename?: 'UserExperienceLevel';
  crochet?: Maybe<UserExperienceLevelEnum>;
  knit?: Maybe<UserExperienceLevelEnum>;
};

export enum UserExperienceLevelEnum {
  Advanced = 'advanced',
  Expert = 'expert',
  Intermediate = 'intermediate',
  Novice = 'novice',
  Unknown = 'unknown'
}

export type UsernameCheckResponse = {
  __typename?: 'UsernameCheckResponse';
  available: Scalars['Boolean']['output'];
};

export type UsersMutations = {
  __typename?: 'UsersMutations';
  createImageUploadOptions: ImageUploadOptions;
  deleteAvatar: DeleteAvatarResponse;
  setAvatar: SetAvatarResponse;
  updateProfile?: Maybe<UpdateProfileResponse>;
};


export type UsersMutationsCreateImageUploadOptionsArgs = {
  input: UploadImageInput;
};


export type UsersMutationsDeleteAvatarArgs = {
  uuid: Scalars['String']['input'];
};


export type UsersMutationsSetAvatarArgs = {
  input: SetAvatarInput;
};


export type UsersMutationsUpdateProfileArgs = {
  input: UpdateProfileInput;
};

export type UsersQueries = {
  __typename?: 'UsersQueries';
  current?: Maybe<User>;
  getAvatar: GetAvatarResponse;
  usernameCheck?: Maybe<UsernameCheckResponse>;
};


export type UsersQueriesGetAvatarArgs = {
  uuid: Scalars['String']['input'];
};


export type UsersQueriesUsernameCheckArgs = {
  username: Scalars['String']['input'];
};

export type ReadNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', readNotification?: { __typename?: 'ReadNotificationResponse', success: boolean } | null } | null };

export type ReadNotificationsMutationVariables = Exact<{
  input?: InputMaybe<ReadNotificationsInput>;
}>;


export type ReadNotificationsMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', readNotifications?: { __typename?: 'ReadNotificationsResponse', success: boolean } | null } | null };

export type SeenUserNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type SeenUserNotificationsMutation = { __typename?: 'Mutation', notification?: { __typename?: 'NotificationMutations', seenUserNotifications: { __typename?: 'SuccessResponse', success: boolean } } | null };

export type AcceptMutationVariables = Exact<{
  alias: Scalars['String']['input'];
}>;


export type AcceptMutation = { __typename?: 'Mutation', toc?: { __typename?: 'TocMutations', accept?: { __typename?: 'TermAcceptResponse', success: boolean } | null } | null };

export type StarterDataQueryVariables = Exact<{
  input: GetNotificationsInput;
  alias: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type StarterDataQuery = { __typename?: 'Query', notification?: { __typename?: 'NotificationQueries', notifications: { __typename?: 'NotificationsResponse', unread: number, unseen: number } } | null, toc?: { __typename?: 'TocQueries', status?: { __typename?: 'TermStatusResponse', success: boolean } | null } | null, community?: { __typename?: 'CommunityQueries', profile?: { __typename?: 'Profile', followers_count: number, following_count: number, user: { __typename?: 'CommunityAuthor', id: string, bio?: string | null, username: string, display_name: string, country?: string | null, avatar_url: string } } | null } | null };

export type NotificationsQueryVariables = Exact<{
  input: GetNotificationsInput;
}>;


export type NotificationsQuery = { __typename?: 'Query', notification?: { __typename?: 'NotificationQueries', notifications: { __typename?: 'NotificationsResponse', unread: number, unseen: number, total: number, cursor?: string | null, notifications: Array<{ __typename?: 'Notification', id: string, message: string, read_at?: string | null, created_at: string, sourceable_type: SourceType, sourceable_id: string, actor: { __typename?: 'CommunityAuthor', display_name: string, avatar_url: string }, subject: { __typename?: 'Comment', id: string, post_id: string } | { __typename?: 'Post', id: string } }> } } | null };

export type CountryConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryConfigsQuery = { __typename?: 'Query', countryConfigs?: Array<{ __typename?: 'CountryConfig', countryCode?: string | null, shopifyConfig?: { __typename?: 'ShopifyConfig', storeEndpoint?: string | null, storefront?: { __typename?: 'ShopifyStorefront', endpoint?: string | null, name?: string | null, publicAccessToken?: string | null } | null } | null } | null> | null };

export type CustomerContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerContentQuery = { __typename?: 'Query', customerContent: { __typename?: 'CustomerContentResponse', content: Array<{ __typename?: 'Pattern', id: string, sku: string, url: string, createdAt?: string | null, updatedAt?: string | null } | null> } };

export type PostsQueryVariables = Exact<{
  galleryContext?: InputMaybe<ContextInput>;
  qaContext?: InputMaybe<ContextInput>;
}>;


export type PostsQuery = { __typename?: 'Query', community?: { __typename?: 'CommunityQueries', gallery?: { __typename?: 'PostsResponse', total?: number | null } | null, qa?: { __typename?: 'PostsResponse', total?: number | null } | null } | null };

export type LoyaltyQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyQuery = { __typename?: 'Query', loyalty?: { __typename?: 'LoyaltyQueries', points?: { __typename?: 'PointsResponse', cursor?: string | null, limit: number, points: Array<{ __typename?: 'Point', amount: number, created_at: string, type: string, description: string }> } | null } | null };

export type PatternBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  urlVersion?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  contactUUID?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PatternBySkuQuery = { __typename?: 'Query', patternBySku?: { __typename?: 'Pattern', url: string, sku: string, id: string, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetCountriesDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesDataQueryQuery = { __typename?: 'Query', countryConfigs?: Array<{ __typename?: 'CountryConfig', countryCode?: string | null, shopifyConfig?: { __typename?: 'ShopifyConfig', storeEndpoint?: string | null } | null, legacyStore?: { __typename?: 'Store', id: number, name: string, country: string, country_switcher_allowed: boolean, is_international: boolean, language: string, url: string, currency?: string | null } | null } | null> | null };


export const ReadNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notification_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const ReadNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReadNotificationsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const SeenUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SeenUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seenUserNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<SeenUserNotificationsMutation, SeenUserNotificationsMutationVariables>;
export const AcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Accept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptMutation, AcceptMutationVariables>;
export const StarterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StarterData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetNotificationsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"unseen"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"toc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followers_count"}},{"kind":"Field","name":{"kind":"Name","value":"following_count"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StarterDataQuery, StarterDataQueryVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"unseen"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"read_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"actor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceable_type"}},{"kind":"Field","name":{"kind":"Name","value":"sourceable_id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Post"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"post_id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const CountryConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefront"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publicAccessToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeEndpoint"}}]}}]}}]}}]} as unknown as DocumentNode<CountryConfigsQuery, CountryConfigsQueryVariables>;
export const CustomerContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pattern"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerContentQuery, CustomerContentQueryVariables>;
export const PostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Posts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"galleryContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qaContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContextInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"community"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gallery"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"galleryContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"qa"},"name":{"kind":"Name","value":"posts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qaContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<PostsQuery, PostsQueryVariables>;
export const LoyaltyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loyalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoyaltyQuery, LoyaltyQueryVariables>;
export const PatternBySkuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatternBySku"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sku"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactUUID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patternBySku"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sku"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sku"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlVersion"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<PatternBySkuQuery, PatternBySkuQueryVariables>;
export const GetCountriesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountriesDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeEndpoint"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_switcher_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"is_international"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<GetCountriesDataQueryQuery, GetCountriesDataQueryQueryVariables>;